import requisicaoSegura from '@/auth/requisicaoSegura';
import {
  APIRecuperarPedidoCarrinho,
  APIResponseListagemCartoes,
  APIResponseNovoPedido,
  APIResponseStatusPedido,
  NovoPedidoRequest,
} from './types/pagamento';
import { schemaNovoPedidoRequest } from './validators/validarNovoPedidoRequest';
import { transformarPedido } from './business';

export async function listarCartoesUsuario(): Promise<APIResponseListagemCartoes> {
  const responseListagemCartoes: APIResponseListagemCartoes =
    await requisicaoSegura({
      endpoint: '/Marketplace/BuscarCartoesUsuario',
      dataForm: {},
    });

  return responseListagemCartoes;
}

export async function realizarNovoPedido(
  formRealizarPedido: NovoPedidoRequest,
): Promise<APIResponseNovoPedido> {
  try {
    await schemaNovoPedidoRequest.validate(
      {
        ...formRealizarPedido,
        ...(formRealizarPedido.mesVencimento && formRealizarPedido.anoVencimento
          ? {
              dataVencimento: `${formRealizarPedido.mesVencimento}/${formRealizarPedido.anoVencimento}`,
            }
          : {}),
      },
      { abortEarly: false },
    );

    const responseCriacaoNovoPedido: APIResponseNovoPedido =
      await requisicaoSegura({
        endpoint: '/Marketplace/NovoPedido',
        dataForm: {
          ...transformarPedido(formRealizarPedido),
          ...(formRealizarPedido?.metaTrack
            ? { metaTrack: formRealizarPedido?.metaTrack }
            : undefined),
        },
      });

    return responseCriacaoNovoPedido;
  } catch (error: unknown) {
    throw new Error(
      error instanceof Error
        ? `${error.name} \n ${error.stack} \n ${error.message}`
        : 'Ocorreu um erro ao realizar seu pedido. Verifique seus dados',
    );
  }
}

export async function recuperarPedidoComFalha(
  pedidoID: string,
): Promise<APIRecuperarPedidoCarrinho> {
  const responseRecuperarPedidoCarrinho: APIRecuperarPedidoCarrinho =
    await requisicaoSegura({
      endpoint: '/Marketplace/RecuperarPedidoCarrinho',
      dataForm: { pedidoID },
    });

  return responseRecuperarPedidoCarrinho;
}

export async function alterarFormaPagamentoPedido(
  formRecuperarPedido: NovoPedidoRequest,
): Promise<APIResponseNovoPedido> {
  const responseAlterarFormaPagamentoPedido: APIResponseNovoPedido =
    await requisicaoSegura({
      endpoint: '/Marketplace/AlterarPagamento',
      dataForm: formRecuperarPedido,
    });

  return responseAlterarFormaPagamentoPedido;
}

export async function trocarMetodoPagamento(
  formTrocarMetodoPagamento: Omit<NovoPedidoRequest, 'pedidoID'> & {
    assinaturaID: string;
    cobrar: boolean;
  },
): Promise<APIResponseNovoPedido> {
  const responseAlterarFormaPagamentoPedido: APIResponseNovoPedido =
    await requisicaoSegura({
      endpoint: '/Marketplace/TrocarMetodoPagamento',
      dataForm: formTrocarMetodoPagamento,
    });

  return responseAlterarFormaPagamentoPedido;
}

export async function verificarStatusPedidoPix(
  pedidoID: string,
): Promise<APIResponseStatusPedido> {
  const responseVerificarStatusPedidoPix: APIResponseStatusPedido =
    await requisicaoSegura({
      endpoint: '/Marketplace/VerficarStatusPedido',
      dataForm: {
        pedidoID,
      },
    });

  return responseVerificarStatusPedidoPix;
}
